export default "__VITE_ASSET__3626bd63__"